import { parseParamsStr } from "~/utils";
import { DiscoveryAction } from "./interfaces";

// admin_time_open_sidebar
// open_discovery(tag=admin-time.month.contracts)
//
export const parseActionString = (action: string): DiscoveryAction[] => {
    const result: DiscoveryAction[] = [];
    const items = action.split(";").filter(Boolean);

    for (const item of items) {
        const withParams = item.match(/([a-zA-Z_]+)\((.*)\)/);

        if (withParams) {
            const [, key, paramsStr] = withParams;
            const params = parseParamsStr(paramsStr);

            result.push({ key, params });
        } else if (item.match(/[a-zA-Z_0-9]+/)) {
            result.push({ key: item });
        }
    }

    return result;
};
